import Link from '@commons/components/Link';

import type { PodcastNodeProps } from '.';

/**
 * Podcast node component for the Label display type.
 */

const PodcastNodeLabel = ({ title, alias }: PodcastNodeProps) => {
  return <Link href={alias}>{title}</Link>;
};

export default PodcastNodeLabel;
